"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Error;
(function (Error) {
    Error["SRC_PARSE"] = "error-src-parse";
    Error["MANIFEST_LOAD"] = "error-manifest-load";
    Error["MANIFEST_PARSE"] = "error-manifest-parse";
    Error["MANIFEST_INCOMPATIBLE"] = "error-manifest-incompatible";
    Error["LEVEL_LOAD"] = "error-level-load";
    Error["CONTENT_LOAD"] = "error-content-load";
    Error["CONTENT_PARSE"] = "error-content-parse";
    Error["MEDIA"] = "error-media";
    Error["UNKNOWN"] = "error-unknown";
})(Error || (Error = {}));
exports.default = Error;
//# sourceMappingURL=errors.js.map